import React from 'react';
import { useTranslation } from 'react-i18next';
import ListPageHeader from '@shared/ListPageHeader';
import WebhookDeliveryList from '@shared/webhook_deliveries/WebhookDeliveryList';
import { webhookDeliveryService } from '@services/admin/webhookDeliveryService';

export default function AdminWebhookDeliveriesList() {
  const { t } = useTranslation();

  return (
    <div>
      <ListPageHeader basePath="/admin" items={['developer_tools', 'developer_tools.webhook_deliveries']} />
      <WebhookDeliveryList role="admin" service={webhookDeliveryService} />
    </div>
  );
}
